import * as actionTypes from '../actionTypes'

import { saveFileFromResponse } from '../../../helpers/utils'
import { enqueueSnackbar } from '../alert'
import reportAxios from '../../../axios/report'

export const reportDataEntry = recordData => {
  return dispatch => {
    dispatch(reportDataEntryStart())

    reportAxios
      .post('/report_data_entry', recordData, { responseType: 'blob' })
      .then(response => {
        // if (recordData.format === 'xls') {
        saveFileFromResponse(response)
        // }
        dispatch(
          enqueueSnackbar({
            message: 'Report Data Entry',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(reportDataEntrySuccess(response.data))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Error',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: 'Error Report Data Entry',
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(reportDataEntryFailed())
      })
  }
}

export const reportDataEntryStart = () => {
  return {
    type: actionTypes.REPORT_DATA_ENTRY_START
  }
}

export const reportDataEntrySuccess = data => {
  return {
    type: actionTypes.REPORT_DATA_ENTRY_SUCCESS,
    data
  }
}

export const reportDataEntryFailed = () => {
  return {
    type: actionTypes.REPORT_DATA_ENTRY_FAILED
  }
}

export const clearReportDataEntry = () => {
  return {
    type: actionTypes.CLEAR_REPORT_DATA_ENTRY
  }
}
